export default "__VITE_ASSET__0153390b__"